

























import Component from 'vue-class-component';
import Vue from 'vue';
import { Emit, Watch } from 'vue-property-decorator';
import {
    createChartPeriodListItems,
    parseChartPeriodListItem,
    toStrChartPeriod
} from '@/utils';
import {
    IDictionary,
    IFormControl,
    IListItem,
    GroupBy,
    IGetOfficePeriodsChartModel
} from '../../../entities';
import { FormFilterComponent } from '../../../components/base/form-filter/form-filter.component';

@Component({})
export default class OfficeProgressChartCriteria extends FormFilterComponent {
    public periods: IListItem[] = createChartPeriodListItems();

    public formState: IDictionary<IFormControl> = {
        period: {
            key: 'period',
            label: 'Period',
            value: null
        }
    };

    public async created() {
        this.formState.period.value = this.periods[
            this.periods.length - 2
        ].value;
        this.doSearch();
    }

    @Emit()
    public search(body: IGetOfficePeriodsChartModel) {
        // empty
    }

    public defaultFormValues(): IDictionary<any> {
        return {
            period: this.periods[this.periods.length - 2].value
        };
    }

    public getQueryObject(formState: IDictionary<IFormControl>) {
        return {
            period: toStrChartPeriod(
                parseChartPeriodListItem(formState.period.value)
            )
        };
    }

    @Watch('formState.period.value')
    private onTypeIdChanged(val: string, oldVal: string) {
        this.submit();
    }

    @Watch('$route') private onRouteChanged(val: string, oldVal: string) {
        this.doSearch();
    }
}
